module.exports = __webpack_public_path__ + "static/media/Board.3bc0e423.jpeg";